export var LOYALTY_MARKETS = Object.freeze({
  IT: "IT",
  CH: "CH"
});
var IT_CONVENTION_TYPES = Object.freeze(["BUS", "UNI", "WAO", "VIP", "QRCODE"]);
var CH_CONVENTION_TYPES = Object.freeze(["BUS"]);
var ITALIAN_LOYALTY_LEGAL_PATHS = Object.freeze(["/condizioni-m-loyalty", "/informativa-m-loyalty"]);
export var resolveLoyaltyMarket = storeViewCode => {
  var normalizedStoreViewCode = String(storeViewCode || "").trim().toLowerCase();
  return normalizedStoreViewCode.startsWith("miscusi_ch") ? LOYALTY_MARKETS.CH : LOYALTY_MARKETS.IT;
};
export var isSwissEmployeeCouponTable = function () {
  var {
    storeViewCode,
    tableDescription,
    customerEmail
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return resolveLoyaltyMarket(storeViewCode) === LOYALTY_MARKETS.CH && tableDescription === "D50" && Boolean(customerEmail);
};
var normalizeConfiguredUrl = value => {
  if (typeof value !== "string") {
    return null;
  }
  var url = value.trim();
  if (!url) {
    return null;
  }
  if (url.startsWith("/") && !url.startsWith("//")) {
    return url;
  }
  try {
    var parsedUrl = new URL(url);
    var isLocalDevelopmentUrl = parsedUrl.protocol === "http:" && ["localhost", "127.0.0.1"].includes(parsedUrl.hostname);
    return parsedUrl.protocol === "https:" || isLocalDevelopmentUrl ? parsedUrl.toString() : null;
  } catch (error) {
    return null;
  }
};
var normalizeSwissLegalUrl = value => {
  var url = normalizeConfiguredUrl(value);
  if (!url || url.startsWith("/")) {
    return null;
  }
  var pathname = new URL(url).pathname.replace(/\/$/, "");
  return ITALIAN_LOYALTY_LEGAL_PATHS.includes(pathname) ? null : url;
};
export var createLoyaltyCapabilities = function () {
  var {
    storeViewCode,
    isCouponActive = false,
    isEdenredWalletActive = false,
    chTermsUrl,
    chPrivacyUrl
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var market = resolveLoyaltyMarket(storeViewCode);
  var isSwitzerland = market === LOYALTY_MARKETS.CH;
  var termsUrl = isSwitzerland ? normalizeSwissLegalUrl(chTermsUrl) : "/condizioni-m-loyalty";
  var privacyUrl = isSwitzerland ? normalizeSwissLegalUrl(chPrivacyUrl) : "/informativa-m-loyalty";
  return Object.freeze({
    market,
    isSwitzerland,
    accountAccess: true,
    pointsEarning: true,
    pointsBalanceHistory: !isSwitzerland,
    pointsRedemption: true,
    companyConventions: true,
    accountBookings: true,
    accountHelp: !isSwitzerland,
    consentManagement: !isSwitzerland,
    coupons: !isSwitzerland && Boolean(isCouponActive),
    birthdayBenefit: !isSwitzerland,
    universityConvention: !isSwitzerland,
    doublePointsBenefit: !isSwitzerland,
    climateSquadBenefit: !isSwitzerland,
    dateOfBirthCollection: !isSwitzerland,
    profilingConsent: !isSwitzerland,
    edenredWallet: !isSwitzerland && Boolean(isEdenredWalletActive),
    supportedConventionTypes: isSwitzerland ? CH_CONVENTION_TYPES : IT_CONVENTION_TYPES,
    fallbackCurrencyCode: isSwitzerland ? "CHF" : "EUR",
    fallbackCurrencySymbol: isSwitzerland ? "CHF" : "€",
    legal: Object.freeze({
      termsUrl,
      privacyUrl,
      ready: Boolean(termsUrl && privacyUrl),
      consentRequired: !isSwitzerland || Boolean(termsUrl && privacyUrl),
      requiresDeploymentConfiguration: isSwitzerland
    })
  });
};